
import Vue from 'vue';
// import { State } from '@/stores/auth';

// declare module 'vue/types/vue' {
//   interface Vue {
//     $auth: State;
//   }
// }
export default Vue.extend({
  methods: {
    $loading(loading: boolean) {
      this.$stores.loading.setIsLoading(loading);
    },
  },
});
